import { useLocationController_LocationWeightStatus } from '@/services/hooks';

import { type DomainQuery, useMappedQuery } from '../shared/query';

import { toDailyCageWeights } from './mappers';
import type { DailyCageWeight } from './types';

/** Each pen's latest weight estimate at the location. */
export function useGetLocationWeightStatus(locationId: number): DomainQuery<DailyCageWeight[]> {
    return useMappedQuery(
        useLocationController_LocationWeightStatus(locationId),
        toDailyCageWeights
    );
}
